import React from 'react';
import { CBadge } from '@coreui/react';
import { UserRole } from '../../../reducers/userReducer';

const CustomerRoleBadge = ({ role }: { role: UserRole }) => {
  const colors: any = {
    SUPERADMIN: 'dark',
    ADMIN: 'success',
    BACKOFFICE_AGENT: 'primary',
    AUDIT_AGENT: 'secondary',
    TRADER: 'danger',
    AFFILIATE: 'primary',
    LEADER: 'info',
    SALES: 'warning',
    GROUP_ADMIN: 'success',
  };

  return <CBadge color={colors[role]}>{role}</CBadge>;
};

export default CustomerRoleBadge;
